module.exports = [{"name":"Over-Quota Collection Guidelines","papers":[{"title":"Over-Quota Collection Guidelines","id":"auth0-ss-oq","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg","date":"October, 2019","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/2019/ss-oq.pdf"},{"action":"open","file":"https://cdn.auth0.com/website/legal/files/2019/ss-oq.pdf"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/ss-oq-collection-guidelines/data/ssOqPapers.json
// module id = 1538
// module chunks = 0